export default __webpack_public_path__ + "static/media/mwoa.d877be56.JPG";